import { useSuperHubStore } from '@core/store';
import { isVersion } from '@core/store/SuperHub/util';

/**
 * If the user is currently viewing a version, returns that version
 * representation. If the user is currently viewing a branch, returns that
 * branch's base version.
 *
 * ⚠️ Note that this hook should only be used for functionality which is
 * intentionally only available for versions and not branches (e.g. Metrics).
 * If your functionality should also be available for branches, use the
 * `currentBranch` field from `useSuperHubStore` directly.
 */
export function useCurrentVersion() {
  const [currentBranch] = useSuperHubStore(s => [s.currentBranch]);

  return isVersion(currentBranch) ? currentBranch : currentBranch.base;
}
